import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#table-with-fixed-column" }),
  /*#__PURE__*/_createTextVNode(" Table with fixed column ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " When there are too many columns, you can fix some of them. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Edit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "date",
            label: "Date",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "state",
            label: "State",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "city",
            label: "City",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "address",
            label: "Address",
            width: "600"
          }),
          _createVNode(_component_el_table_column, {
            prop: "zip",
            label: "Zip",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "Operations",
            width: "120"
          }, {
            default: _withCtx(() => [
              _createVNode("template", null, [
                _createVNode(_component_el_button, {
                  onClick: _ctx.handleClick,
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}